export const config = () => {
    let ENV: string;
    let LOGIN_API: string;
    let emailValidator: any;
    let BASE_URL: string;
    let SALESFORCE_URL: string;
    let SALESFORCE_DOWNLOAD_API_URL: string;
    let ORIGINATE_CALL_URL: string;
    let SALESFORCE_EASEBUZZ_PAYMENT_URL: string;

    ENV = process.env.REACT_APP_ENV;
    BASE_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000/api";
    SALESFORCE_URL = process.env.REACT_APP_SALESFORCE_API_URL;
    SALESFORCE_DOWNLOAD_API_URL = process.env.REACT_APP_SALESFORCE_DOWNLOAD_API_URL;
    ORIGINATE_CALL_URL = process.env.REACT_APP_ORIGINATE_WEB_CALLING_URL || process.env.REACT_APP_ORIGINATE_CALL_URL || "https://4s4ks5n10h.execute-api.ap-south-1.amazonaws.com/v1/originate_web_calling";
    SALESFORCE_EASEBUZZ_PAYMENT_URL = process.env.REACT_APP_SALESFORCE_EASEBUZZ_PAYMENT_URL || "https://casagrandbuilderprivatelimited.my.salesforce.com/services/apexrest/easebuzz/payment/";

    return {
        ENV,
        LOGIN_API,
        BASE_URL,
        emailValidator,
        SALESFORCE_URL,
        SALESFORCE_DOWNLOAD_API_URL,
        ORIGINATE_CALL_URL,
        SALESFORCE_EASEBUZZ_PAYMENT_URL,
    };
};
